import BabylistButtonBanner from './babylist-button-banner'

export default BabylistButtonBanner
